import Alpine from 'alpinejs'
import accordion from './modules/accordion'
import cf7 from './modules/cf7'
import { bootstrapReactApps } from './bootstrapReactApps'

accordion()
cf7()
bootstrapReactApps()

window.Alpine = Alpine

Alpine.start()
